import { apiFetch } from "./apiFetch";

export async function submitDispute(bookingId, reason, description) {
  return apiFetch("/api/disputes", {
    method: "POST",
    body: JSON.stringify({ bookingId, reason, description: description || null }),
  });
}
